import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTag = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.612 14.875 15.75 4.013a1.734 1.734 0 0 0-1.237-.513H4.375a.875.875 0 0 0-.875.875v10.138a1.735 1.735 0 0 0 .513 1.237l10.862 10.862a1.75 1.75 0 0 0 2.475 0l9.262-9.262a1.75 1.75 0 0 0 0-2.475Zm-10.5 10.5L5.25 14.513V5.25h9.263l10.862 10.862-9.263 9.263ZM10.5 9.188a1.313 1.313 0 1 1-2.625 0 1.313 1.313 0 0 1 2.625 0Z" />
  </svg>
);
export default SvgTag;
